module.exports = __webpack_public_path__ + "media/img/email/external_link_blue-767d996ce8670daedf70c6bc7ed2407f.png";